module.exports = __webpack_public_path__ + "img/file-certificate-light.dab43ad9.svg";